export default __webpack_public_path__ + "static/media/support.264021dd.svg";